import type { LevelData } from './game';

/**
 * XSB 字符对照：
 * # (墙), . (目标), $ (箱子), * (箱在点), @ (人), + (人在点), 空格 (地)
 */
function parseXSB(name: string, xsb: string): LevelData {
    // 移除字符串开头和结尾的空行，但保留每行内部的空格
    const lines = xsb.replace(/^\n+|\n+$/g, '').split('\n');
    // 找出最长的一行，确保地图是矩形
    const maxWidth = Math.max(...lines.map(l => l.length));

    const charMap: Record<string, number> = {
        '#': 1, ' ': 0, '.': 2, '$': 3, '*': 4, '@': 5, '+': 6
    };

    const map = lines.map(line => {
        const row = line.padEnd(maxWidth, ' ').split('').map(char => charMap[char] ?? 0);
        return row;
    });

    return { name, map };
}

export const levels: LevelData[] = [
    parseXSB("1", "    #####\n    #   #\n    #$  #\n  ###  $##\n  #  $ $ #\n### # ## #   ######\n#   # ## #####  ..#\n# $  $          ..#\n##### ### #@##  ..#\n    #     #########\n    #######"),
    parseXSB("2", "############\n#..  #     #\n#..  # $  $#\n#..  #$#####\n#..    @   #\n#..  # #   #\n###### ##$ #\n  # $ $ $ $#\n  #    #   #\n  ##########"),
    parseXSB("3", "        ########\n        #     @#\n        # $#$ ##\n        # $  $#\n        ## #  #\n#########  ## #   ######\n#....  ## $  # #  #    #\n#....          ####    #\n#....  ##$  #  #       #\n#########  ##$ #  ######\n        ##    ##\n        ########"),
    parseXSB("4", "##########\n#        #\n#  #######\n#  #..   #\n# $#..   #\n#  #..   #\n# $#######\n# $      #\n#  @     #\n##########"),
    parseXSB("5", "      #######\n      #     #\n      # $ $ #\n      #  @  #\n####### $ $ #######\n#.... # $ $ # ....#\n#....       # ....#\n#.... # $ $ # ....#\n####### $ $ #######\n      #  $  #\n      #     #\n      #######"),
    parseXSB("6", "######  ####\n#    ###   #\n# $$       #\n# @  ###   #\n###### ######\n  #      #\n  #      #\n  #      #\n  #......#\n  #......#\n  ########"),
    parseXSB("7", "#############\n#..#        #\n#..# $ $ $  #\n#..#  $ $   #\n#..# @ $ $  #\n#..#  $ $   #\n#..#        #\n#############"),
    parseXSB("8", "  ####\n###  ####\n#  $    #\n#  $#$  #\n#  $.$  #\n#  $#$  #\n# @$ $  #\n#    ####\n######"),
    parseXSB("9", "      ########\n      #      #\n      #      #\n      #      #\n#######      #######\n#      $ $ $       #\n#      $ @ $       #\n#      $ $ $       #\n#######      #######\n      #      #\n      #......#\n      #......#\n      #......#\n      ########"),
    parseXSB("10", "############\n#          #\n#  $$$$$$  #\n#  $    $  #\n#  $ .. $  #\n#  $ .. $  #\n#  $ @  $  #\n#  $    $  #\n#  $$$$$$  #\n#          #\n############"),

    // 11-20 进阶挑战
    parseXSB("11", "  #######\n  #     #\n  # $#$ #\n  # $ @ #\n  # $#$ #\n  #     #\n  #######"),
    parseXSB("12", "#######\n#     #\n# $#$ #\n# $.$ #\n# $#$ #\n# @   #\n#######"),
    parseXSB("13", "#######\n#..@..#\n# $#$ #\n#  $  #\n# $#$ #\n#.. ..#\n#######"),
    parseXSB("14", "########\n#      #\n# $#$# #\n# $.$  #\n# $#$# #\n# @    #\n########"),
    parseXSB("15", "#######\n#  .  #\n# $#$ #\n#$.@.$#\n# $#$ #\n#  .  #\n#######"),
    parseXSB("16", "  #####\n###   #\n#  $  #\n# .$. #\n#  $  #\n# @   #\n#######"),
    parseXSB("17", "  #####\n###   #\n# $ $ #\n# .@. #\n# $ $ #\n###   #\n  #####"),
    parseXSB("18", "#######\n#     #\n# .$. #\n# $.$ #\n# .@. #\n#     #\n#######"),
    parseXSB("19", "########\n#  ....#\n#  $$$$#\n#  @   #\n########"),
    parseXSB("20", "########\n#      #\n# $ $ $#\n# . . .#\n# @    #\n########"),
    // --- 21-30 关 ---
    parseXSB("21", "  #####\n  #   #\n  #$  #\n###  $##\n#  $ $ #\n# $ #  #\n#  ... #\n########"),
    parseXSB("22", "#######\n#     #\n# $ $ #\n# .$. #\n# $ $ #\n#  @  #\n#######"),
    parseXSB("23", "  ####\n###  ####\n#  $    #\n#  $#$  #\n#  $.$  #\n#  $#$  #\n# @$ $  #\n#    ####\n######"),
    parseXSB("24", " #####\n #   #\n##$#$##\n# .@. #\n#  #  #\n#######"),
    parseXSB("25", "#######\n#     #\n# $.$ #\n# .@. #\n# $.$ #\n#     #\n#######"),
    parseXSB("26", "  ####\n###  #\n#  $ #\n# @#.#\n#  $ #\n###  #\n  ####"),
    parseXSB("27", "#######\n#     #\n# . . #\n# $ $ #\n#  @  #\n#######"),
    parseXSB("28", " #####\n # . #\n##$#$##\n# .@. #\n#######"),
    parseXSB("29", "#######\n# @   #\n# $ $ #\n# . . #\n#######"),
    parseXSB("30", " #####\n # . #\n##$#$##\n#  @  #\n#######"),

    // --- 31-40 关 ---
    parseXSB("31", "#######\n#     #\n# $ $ #\n# . . #\n#  @  #\n#######"),
    parseXSB("32", "  #####\n###   #\n#  $. #\n# @   #\n#######"),
    parseXSB("33", "#######\n#     #\n#  $  #\n# .@  #\n#######"),
    parseXSB("34", "#######\n#     #\n#  .  #\n#  $  #\n#  @  #\n#######"),
    parseXSB("35", "#######\n#  .  #\n#  $  #\n# @   #\n#######"),
    parseXSB("36", "#######\n#     #\n# $   #\n# .   #\n# @   #\n#######"),
    parseXSB("37", "#######\n#     #\n# .   #\n# $   #\n# @   #\n#######"),
    parseXSB("38", "#######\n#     #\n# @   #\n# $   #\n# .   #\n#######"),
    parseXSB("39", "#######\n#     #\n# @   #\n# .   #\n# $   #\n#######"),
    parseXSB("40", "#######\n#     #\n# $   #\n# @   #\n# .   #\n#######"),

    // --- 41-50 关 ---
    parseXSB("41", "#######\n#     #\n# .   #\n# @   #\n# $   #\n#######"),
    parseXSB("42", "  #####\n###   #\n#  $. #\n#  @  #\n#######"),
    parseXSB("43", "#######\n#     #\n#  $  #\n#  .  #\n#  @  #\n#######"),
    parseXSB("44", "#######\n#     #\n#  .  #\n#  $  #\n#  @  #\n#######"),
    parseXSB("45", "#######\n#     #\n#  @  #\n#  $  #\n#  .  #\n#######"),
    parseXSB("46", "#######\n#     #\n#  @  #\n#  .  #\n#  $  #\n#######"),
    parseXSB("47", "#######\n#     #\n#  $  #\n#  @  #\n#  .  #\n#######"),
    parseXSB("48", "#######\n#     #\n#  .  #\n#  @  #\n#  $  #\n#######"),
    parseXSB("49", "#######\n#     #\n# $ . #\n#  @  #\n#######"),
    parseXSB("50", "#######\n#     #\n# . $ #\n#  @  #\n#######"),
    // --- 51-60 关 ---
    parseXSB("51", "#######\n#     #\n# @ . #\n#  $  #\n#######"),
    parseXSB("52", "#######\n#     #\n# @ $ #\n#  .  #\n#######"),
    parseXSB("53", "#######\n#     #\n# $ @ #\n#  .  #\n#######"),
    parseXSB("54", "#######\n#     #\n# . @ #\n#  $  #\n#######"),
    parseXSB("55", "  ####\n###  #\n#  $ #\n#@$ .#\n#  . #\n######"),
    parseXSB("56", "#####\n#@  #\n# $ #\n# $ #\n# ..#\n#####"),
    parseXSB("57", "######\n#@   #\n# $$ #\n# .. #\n#    #\n######"),
    parseXSB("58", "#######\n# . . #\n# $ $ #\n#  @  #\n#######"),
    parseXSB("59", "#######\n# $ $ #\n# . . #\n#  @  #\n#######"),
    parseXSB("60", "#######\n# . @ #\n# $ . #\n# $   #\n#######"),

    // --- 61-70 关 ---
    parseXSB("61", "#######\n#  $  #\n# .@. #\n#  $  #\n#######"),
    parseXSB("62", "#######\n#  .  #\n# $@$ #\n#  .  #\n#######"),
    parseXSB("63", "  ####\n###  ####\n#  $ .  #\n# @$ $ .#\n#  .    #\n#########"),
    parseXSB("64", "#######\n#     #\n# $.$ #\n# @   #\n#######"),
    parseXSB("65", "#######\n#  .  #\n# $#$ #\n#  @  #\n#######"),
    parseXSB("66", "#######\n# @   #\n# $#$ #\n#  .  #\n#######"),
    parseXSB("67", "#######\n# .   #\n# $#$ #\n# @   #\n#######"),
    parseXSB("68", "#######\n# @   #\n# $#$ #\n# .   #\n#######"),
    parseXSB("69", "  #####\n###   #\n#  $#.#\n# @   #\n#######"),
    parseXSB("70", "#######\n#     #\n# $#  #\n# .@  #\n#######"),
    // --- 71-80 关 ---
    parseXSB("71", "#######\n#     #\n# .#  #\n#  $  #\n#  @  #\n#######"),
    parseXSB("72", "#######\n#     #\n#  @  #\n#  $  #\n#  .#  #\n#######"),
    parseXSB("73", "#######\n#     #\n#  @  #\n#  .#  #\n#  $  #\n#######"),
    parseXSB("74", "#######\n#     #\n#  $  #\n#  @  #\n#  .#  #\n#######"),
    parseXSB("75", "#######\n#     #\n#  .#  #\n#  @  #\n#  $  #\n#######"),
    parseXSB("76", "#######\n#     #\n# $ . #\n#  @# #\n#######"),
    parseXSB("77", "#######\n#     #\n# . $ #\n#  @# #\n#######"),
    parseXSB("78", "#######\n#     #\n# @ . #\n#  $# #\n#######"),
    parseXSB("79", "#######\n#     #\n# @ $ #\n#  .# #\n#######"),
    parseXSB("80", "#######\n#     #\n# $ @ #\n#  .# #\n#######"),

    // --- 81-90 终极挑战 ---
    parseXSB("81", "#######\n#     #\n# . @ #\n#  $# #\n#######"),
    parseXSB("82", "########\n#  . . #\n# #$#$ #\n#@$ .  #\n########"),
    parseXSB("83", "  ####\n###  #\n#  $ #\n#@$ .#\n#  . #\n######"),
    parseXSB("84", "#####\n#@  #\n# $ #\n# $ #\n# ..#\n#####"),
    parseXSB("85", "######\n#@   #\n# $$ #\n# .. #\n#    #\n######"),
    parseXSB("86", "#######\n# . . #\n# $ $ #\n#  @  #\n#######"),
    parseXSB("87", "#######\n# $ $ #\n# . . #\n#  @  #\n#######"),
    parseXSB("88", "#######\n# . @ #\n# $ . #\n# $   #\n#######"),
    parseXSB("89", "  ####\n###  #\n#  $ #\n# @$ #\n#  . #\n#  . #\n######"),
    parseXSB("90", "  ####\n###  ####\n#  $$.  #\n#  $@.  #\n#  $$.  #\n###  ####\n  ####")
]

export const levels2: LevelData[] = [
    parseXSB("第1关", "####\n# .#\n#  ###\n#*@  #\n#  $ #\n#  ###\n####"),
    parseXSB("第2关", "###########\n#    #    #\n#  $ . $  #\n#  @ # .  #\n#    #    #\n###########"),
    parseXSB("第3关", "  ####\n###  ####\n# @   . #\n#  $$.  #\n####  ###\n   ####"),
    parseXSB("第4关", "###########\n#  #  #   #\n# $.  $ . #\n# @#  #   #\n############"),
    parseXSB("第5关", "######\n#    #\n# .. #\n# $$ #\n# @  #\n######"),
    parseXSB("第6关", "##########\n#  .  .  #\n#  $  $  #\n#    @   #\n##########"),
    parseXSB("第7关", " #####\n #   #\n##$#$##\n# .@. #\n#  #  #\n#######"),
    parseXSB("第8关", "#######\n#     #\n# $.$ #\n# .@. #\n# $.$ #\n#     #\n#######"),
    parseXSB("第9关", "  #####\n###   #\n# @$$ #\n#  .. #\n#######"),
    parseXSB("第10关", "#######\n#  .  #\n# $#$ #\n# .@. #\n#######"),
    parseXSB("第11关", "  ####\n###  #\n#  $ #\n# @#.#\n#  $ #\n###  #\n  ####"),
    parseXSB("第12关", "#######\n#     #\n# .$. #\n# $@$ #\n# .$. #\n#     #\n#######"),
    parseXSB("第13关", " #####\n #   #\n##$#$##\n# .@. #\n#######"),
    parseXSB("第14关", "  ####\n###  #\n#  $ #\n# .#@#\n#  $ #\n###  #\n  ####"),
    parseXSB("第15关", "#######\n#     #\n# . . #\n# $ $ #\n#  @  #\n#######"),
    parseXSB("第16关", "#######\n# @   #\n# $ $ #\n# . . #\n#######"),
    parseXSB("第17关", " #####\n # . #\n##$#$##\n# .@. #\n#######"),
    parseXSB("第18关", "#######\n#     #\n# $ $ #\n# . . #\n#  @  #\n#######"),
    parseXSB("第19关", " #####\n # . #\n##$#$##\n#  @  #\n#######"),
    parseXSB("第20关", "#######\n#  .  #\n# $#$ #\n#  @  #\n#######"),
    parseXSB("第21关", "#######\n#     #\n# $ $ #\n# .@. #\n#######"),
    parseXSB("第22关", "#######\n#  .  #\n#  $  #\n#  @  #\n#######"),
    parseXSB("第23关", "#####\n#   #\n# @ #\n# $ #\n# . #\n#####"),
    parseXSB("第24关", "#####\n# . #\n# $ #\n# @ #\n#   #\n#####"),
    parseXSB("第25关", "#####\n#   #\n# $ #\n# . #\n# @ #\n#####"),
    parseXSB("第26关", "#######\n#     #\n# $.$ #\n#  @  #\n#######"),
    parseXSB("第27关", "  #####\n###   #\n#  $. #\n# @   #\n#######"),
    parseXSB("get28关", "#######\n#     #\n#  $  #\n# .@  #\n#######"),
    parseXSB("第29关", "#######\n#     #\n#  .  #\n#  $  #\n#  @  #\n#######"),
    parseXSB("第30关", "#####\n# . #\n# $ #\n# @ #\n#####"),
    parseXSB("第31关", "#######\n#  .  #\n#  $  #\n# @   #\n#######"),
    parseXSB("第32关", "#######\n#     #\n# $   #\n# .   #\n# @   #\n#######"),
    parseXSB("第33关", "#######\n#     #\n# .   #\n# $   #\n# @   #\n#######"),
    parseXSB("第34关", "#######\n#     #\n# @   #\n# $   #\n# .   #\n#######"),
    parseXSB("第35关", "#######\n#     #\n# @   #\n# .   #\n# $   #\n#######"),
    parseXSB("第36关", "#######\n#     #\n# $   #\n# @   #\n# .   #\n#######"),
    parseXSB("第37关", "#######\n#     #\n# .   #\n# @   #\n# $   #\n#######"),
    parseXSB("第38关", "  #####\n###   #\n#  $. #\n#  @  #\n#######"),
    parseXSB("第39关", "#######\n#     #\n#  $  #\n#  .  #\n#  @  #\n#######"),
    parseXSB("第40关", "#######\n#     #\n#  .  #\n#  $  #\n#  @  #\n#######"),
    parseXSB("第41关", "#######\n#     #\n#  @  #\n#  $  #\n#  .  #\n#######"),
    parseXSB("第42关", "#######\n#     #\n#  @  #\n#  .  #\n#  $  #\n#######"),
    parseXSB("第43关", "#######\n#     #\n#  $  #\n#  @  #\n#  .  #\n#######"),
    parseXSB("第44关", "#######\n#     #\n#  .  #\n#  @  #\n#  $  #\n#######"),
    parseXSB("第45关", "#######\n#     #\n# $ . #\n#  @  #\n#######"),
    parseXSB("第46关", "#######\n#     #\n# . $ #\n#  @  #\n#######"),
    parseXSB("第47关", "#######\n#     #\n# @ . #\n#  $  #\n#######"),
    parseXSB("第48关", "#######\n#     #\n# @ $ #\n#  .  #\n#######"),
    parseXSB("第49关", "#######\n#     #\n# $ @ #\n#  .  #\n#######"),
    parseXSB("第50关", "#######\n#     #\n# . @ #\n#  $  #\n#######")
];

export const totalLevels: number = levels.length;